import React, { useEffect, useState } from 'react';
import { api } from './page';

const Leaderboard = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchBoard = async () => {
    setLoading(true);
    try {
      const res = await api.get('/getallLeaderboard');
      console.log("Leaderboard fetched successfully:", res.data);
      setData(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error('fetch leaderboard error', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBoard();
  }, []);

  if (loading) {
    return <div style={{ padding: 12 }}>Loading leaderboard...</div>;
  }

  return (
    <div style={{ padding: 12, border: '1px solid #eee', borderRadius: 6 }}>
      <h3 style={{ marginTop: 0 }}>Leaderboard</h3>
      <div style={{ overflowX: 'auto' }}>
        
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              <th style={th}>Rank</th>
              <th style={th}>Team Name</th>
              <th style={th}>Matches</th>
              <th style={th}>Wins</th>
              <th style={th}>Losses</th>
              <th style={th}>Points</th>
              <th style={th}>Set Ratio</th>
              <th style={th}>Points Ratio</th>
            </tr>
          </thead>
          <tbody>
            
            {data.map((t, i) => (
              <tr key={t._id || t.teamname} style={{ background: i % 2 === 0 ? '#fff' : '#fbfbfb' }}>
                <td style={td}>{i + 1}</td>
                <td style={td}>{t.teamname}</td>
                <td style={td}>{t.totalMatches ?? 0}</td>
                <td style={td}>{t.totalWins ?? 0}</td>
                <td style={td}>{t.totalLosses ?? 0}</td>
                <td style={td}>{t.points ?? 0}</td>
                {/* <td style={td}>
                {t.setRatio != null
                  ? (parseFloat(t.setRatio) === 0 ? "MAX" : parseFloat(t.setRatio).toFixed(2))
                  : "0.00"}
                </td>
                <td style={td}>
                {t.pointsRatio != null
                  ? (parseFloat(t.pointsRatio) === 0 ? "MAX" : parseFloat(t.pointsRatio).toFixed(2))
                  : "0.00"}
                </td> */}
                <td style={td}>{parseFloat(t.setRatio).toFixed(2)}</td>
                <td style={td}>{parseFloat(t.pointsRatio).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{ marginTop: 10 }}>
        <button onClick={fetchBoard} style={{ padding: '6px 10px' }}>Refresh</button>
      </div>
    </div>
  );
};

const th = { padding: '8px 10px', border: '1px solid #eee', textAlign: 'left' };
const td = { padding: '8px 10px', border: '1px solid #eee' };

export default Leaderboard;